import { isNullOrUndefined, Browser } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class Zoom {
    constructor(documentHelper) {
        /**
         * @private
         * @param {WheelEvent} event Specifies the mouse wheen event
         * @returns {void}
         */
        this.onMouseWheelInternal = (event) => {
            if (event.ctrlKey === true) {
                event.preventDefault();
                const viewerLeft = this.documentHelper.viewerContainer.getBoundingClientRect().left;
                const pageX = event.pageX - viewerLeft;
                if (pageX < this.documentHelper.pageContainer.offsetWidth) {
                    let isFirefFox;
                    if (navigator !== undefined) {
                        isFirefFox = navigator.userAgent.match('Firefox');
                    }
                    /* eslint-disable */
                    const wheel = isFirefFox ? event.detail < 0 : (Browser.isIE ? event.wheelDelta > 0 : event.deltaY < 0);
                    /* eslint-enable */
                    let zoomFactor = this.documentHelper.zoomFactor;
                    if (wheel) {
                        if (zoomFactor <= 4.90) {
                            zoomFactor += .10;
                        }
                        else {
                            zoomFactor = 5.00;
                        }
                    }
                    else {
                        if (zoomFactor >= .20) {
                            zoomFactor -= .10;
                        }
                        else {
                            zoomFactor = 0.10;
                        }
                    }
                    this.documentHelper.zoomFactor = zoomFactor;
                }
            }
        };
        this.documentHelper = documentHelper;
    }
    setZoomFactor() {
        this.onZoomFactorChanged();
        if (!isNullOrUndefined(this.documentHelper.selection)) {
            this.documentHelper.selection.updateCaretPosition();
        }
        this.documentHelper.updateTouchMarkPosition();
        if (!isNullOrUndefined(this.documentHelper.owner.imageResizerModule)) {
            this.documentHelper.owner.imageResizerModule.updateImageResizerPosition();
        }
        this.documentHelper.owner.fireZoomFactorChange();
    }
    get viewer() {
        return this.documentHelper.owner.viewer;
    }
    //Zoom Implementation Starts
    onZoomFactorChanged() {
        if (this.documentHelper.zoomFactor > 5) {
            this.documentHelper.zoomFactor = 5;
        }
        else if (this.documentHelper.zoomFactor < 0.1) {
            this.documentHelper.zoomFactor = 0.1;
        }
        this.zoom();
    }
    zoom() {
        const viewer = this.viewer;
        this.documentHelper.clearContent();
        viewer.handleZoom();
        this.documentHelper.updateFocus();
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.documentHelper = undefined;
    }
}
